import { gql } from '@apollo/client';

const GET_PRODUCTS = gql`
  query products(
    $params: QueryParams
    $name: String
    $type: String
  ) {
    products(
      params: $params
      name: $name
      type: $type
    ) {
      info {
        count
      }
     results {
        id
        name
        description
        variants {
          id
          title
          img
          description
          price
          isPrimaryVariant
          product {
            id
            name
            description
          }
        }
        type
      }
    }
  }
`;

export { GET_PRODUCTS }
